export var ModalType;
(function (ModalType) {
    ModalType["Questionnaire"] = "questionnaire";
    ModalType["DisputeDetail"] = "disputeDetail";
    ModalType["DisputeInfo"] = "disputeInfo";
    ModalType["FAQs"] = "FAQs";
    ModalType["CancelDispute"] = "cancelDispute";
    ModalType["UploadDocuments"] = "uploadDocuments";
    ModalType["AdditionalInfo"] = "additionalInfo";
})(ModalType || (ModalType = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "primary";
    ButtonType["Secondary"] = "secondary";
    ButtonType["Ghost"] = "ghost";
    ButtonType["TextDestroy"] = "text-destroy";
})(ButtonType || (ButtonType = {}));
//# sourceMappingURL=typings.js.map